import {
  TDashboardComponent,
  TDashboardRenderComponentProps,
} from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import px from "MyDashboards/utils/px";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";
import ImageEditorEdit from "./ImageEditorEdit/ImageEditorEdit";

const Render = (props: TDashboardRenderComponentProps) => {
  const { el, onReady } = props;
  const ctx = useAppContext();
  const compData = React.useMemo(() => {
    return el.component?.data as any;
  }, [el]);

  if (!el.component) return null;

  /**
   * Render the chart
   */
  return (
    <div
      key={`chart_${el.id}`}
      style={{
        width: px(el.component.width),
        height: px(el.component.height),
        transform: `scale(${el.width / el.component.width})`,
        transformOrigin: ctx.rtl ? "top right" : "top left",
        justifyContent: "unset",
        alignItems: "unset",
      }}
    >
      image editor
    </div>
  );
};

/**
 * This component renders a placeholder box in place of the actual element, can be used as default renderer
 */
const ImageEditor: TDashboardComponent = {
  editorMode: "image",
  Edit: ({
    el,
    onChange,
  }: {
    el: Element;
    onChange: (el: Partial<Element>) => void;
  }) => {
    return <ImageEditorEdit el={el} onChange={onChange} />;
  },
  Render: ({
    el,
    onReady,
  }: {
    el: Element;
    onReady?: (el: Element) => void;
  }) => {
    const ctx = useAppContext();
    if (!el.component) {
      return null;
    }
    return <Render el={el} onReady={onReady} />;
  },
};
export default ImageEditor;
